import { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { Card } from 'react-bootstrap';
import styles from '../../../users/cards/user-card.module.sass';
import * as React from 'react';
import { IUser } from '../../../../model/user';
import { useProjects, useTools } from '../../../../components';
import { CustomSpinner } from '@yakoffice/custom-spinner';
import ProjectUserForm from '../forms/projectUserForm';
import { useProjectUser } from '../../../../components/use-project-users/use-project-user';

export interface UserCardProps {
    user: IUser;
    projectId: string;
    updateCallbackTrigger: (clearActiveUser?: boolean) => void;
}

export const ProjectUserCard: FC<UserCardProps> = observer((props: UserCardProps) => {

    const loadToolsResult = useTools();
    const loadProjectsResult = useProjects();
    const loadUserResult = useProjectUser(props.projectId, props.user);

    return (
        !loadUserResult.isLoaded || !loadProjectsResult.isLoaded || !loadToolsResult.isLoaded
            ? <CustomSpinner spinnerText="Loading User..." />
            : loadUserResult.user &&
            loadProjectsResult.projects &&
            loadToolsResult.tools &&
            <Card key={props.user.id} className={styles.userCard}>
                <Card.Body className={styles.cardBody}>
                    <ProjectUserForm
                        project={loadProjectsResult.projects.filter(project => project.id === props.projectId)[0]}
                        tools={loadToolsResult.tools} user={loadUserResult.user}
                        updateCallbackTrigger={props.updateCallbackTrigger} />
                </Card.Body>
            </Card>
    );
});
